<template>
  <div class="bindPhonePage" id="bindPhonePage" ref="bindPhonePage">
    <TopBack :title="$t('lang.bindPhone.title')"/>

    <div class="page-body">
      <!-- 表单卡 -->
      <section class="card form-card">
        <!-- 手机号 -->
        <label class="field-label">{{ $t('lang.bindPhone.mobileNumber') }}</label>
        <div class="phone-field">
          <div class="phone-input">
            <div class="country" @click.stop="toggleCountryPop">
              <img :src="flag" alt="" class="flag"/>
              <span class="code">{{ currentCountry.code }}</span>
              <svg viewBox="0 0 24 24" class="ic-chev" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <input class="phone" type="tel" inputmode="numeric" v-model="phone" :placeholder="$t('lang.login.mobile')" @input="formatPhone"/>
          </div>

          <!-- 区号下拉：与 Login 页一致，当前仅 India +91 一个选项 -->
          <div class="country-pop" v-if="showCountryPop">
            <div
              v-for="item in countryList"
              :key="item.code"
              class="country-item"
              :class="{active: item.code === currentCountry.code}"
              @click="selectCountry(item)">
              <img :src="flag" alt="" class="flag-sm"/>
              <span>{{ item.label }} {{ item.code }}</span>
            </div>
          </div>
        </div>
        <p class="err-msg" v-if="showPhoneError">{{ $t('lang.bindPhone.phoneError') }}</p>

        <!-- OTP -->
        <div class="otp-head">
          <label class="field-label">{{ $t('lang.bindPhone.enterOtp') }}</label>
          <!-- 倒计时结束（含尚未发送过）时显示可点的 Send；倒计时中显示剩余秒数 -->
          <button class="resend-pill send" type="button" v-if="countdown <= 0" @click="getSns">
            {{ $t('lang.bindPhone.send') }}
          </button>
          <span class="resend-pill" v-else>
            <svg viewBox="0 0 24 24" class="ic-clock" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('lang.bindPhone.resend', {sec: countdown}) }}
          </span>
        </div>
        <div class="otp-boxes">
          <input
            v-for="(d, i) in otp"
            :key="i"
            :ref="'otpBox' + i"
            class="otp-box"
            type="tel"
            maxlength="1"
            inputmode="numeric"
            v-model="otp[i]"
            @input="onOtpInput(i, $event)"
            @keydown.backspace="onOtpBackspace(i, $event)"
            @paste="onOtpPaste($event)"/>
        </div>
        <p class="auto-fill" v-if="false">
          <svg viewBox="0 0 20 20" class="ic-check" fill="currentColor">
            <path clip-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" fill-rule="evenodd"/>
          </svg>
          {{ $t('lang.bindPhone.autoFill') }}
        </p>
      </section>

      <!-- 确认按钮 -->
      <button class="btn-confirm" type="button" @click="onConfirm">{{ $t('lang.bindPhone.confirm') }}</button>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import flag from '@/assets/images/login/IndiaFlag.svg'
import {Toast} from 'mint-ui'
import request from '@/service'

// OTP 重发倒计时时长，与 Login 的 getSns 成功分支保持一致
const OTP_COUNTDOWN_SECONDS = 60

export default {
  name: 'BindPhone',
  components: {TopBack},
  data () {
    return {
      // 静态占位数据：字段/文案取自本地设计图（Bind Phone）。
      // 后端绑定手机/发送验证码接口尚未提供，service/service2 不在本次改动范围；
      // 接口就绪后在 onConfirm / mounted 接入即可。
      flag,
      // 区号可选项：与 Login 页保持一致，目前只开放 India +91
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      countryList: [
        {label: 'India', code: '+91', flag: 'in'}
      ],
      currentCountry: {label: 'India', code: '+91', flag: 'in'},
      showCountryPop: false,
      phone: '',
      otp: ['', '', '', ''],
      // 剩余可重发秒数；<= 0 代表可以发送（与 Login 的 countdown 同义）
      countdown: 0,
      timer: null
    }
  },
  computed: {
    // 印度手机号：普通 10 位；第4位起为 54321 时允许 12 位
    phoneValid () {
      const digits = this.phone.replace(/\s/g, '')
      if (digits.length >= 8 && digits.slice(3, 8) === '54321') return /^\d{12}$/.test(digits)
      return /^\d{10}$/.test(digits)
    },
    showPhoneError () {
      return !this.phoneValid
    }
  },
  mounted () {
    if (!this.userInfo || (this.userInfo && this.userInfo.mobile)) {
      this.$router.go(-1)
      return
    }
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    formatPhone () {
      // 只留数字；第4位起为 54321 时允许 12 位，否则上限 10 位
      const raw = this.phone.replace(/\D/g, '')
      const max = raw.length >= 8 && raw.slice(3, 8) === '54321' ? 12 : 10
      const digits = raw.slice(0, max)
      this.phone = digits.replace(/(\d{5})(?=\d)/g, '$1 ')
    },
    getSns () {
      // 以 Login 的 getSns 为参照；BindPhone 无图形验证码，略去 picSwitch 相关拦截
      if (this.countdown > 0) {
        Toast(this.$t('lang.bindPhone.tooOften', {seconds: this.countdown}))
        return
      }
      if (!this.phoneValid) {
        Toast(this.$t('lang.bindPhone.invalidPhone'))
        return
      }
      const mobile = this.phone.replace(/\s/g, '')
      const data = {
        campaignId: localStorage.getItem('cid'),
        mobile: mobile,
        userId: this.userInfo.userId
      }
      // ==== 发送 OTP ====
      request('post', '/api/user/bind/send/sns', data).then(res => {
        if (res && res.code === 200 && res.message === 'success') {
          this.onSnsSent()
        } else if (res && res.message && res.code !== 200) {
          Toast(res.message)
        }
      })
      console.log('[BindPhone] send otp, mobile =', mobile)
    },
    // 发送成功回调：清空上一轮验证码并启动倒计时
    onSnsSent () {
      this.otp = ['', '', '', '']
      this.countdown = OTP_COUNTDOWN_SECONDS
      this.countdownTimer()
    },
    countdownTimer () {
      // Login 用递归 setTimeout，这里沿用本文件已有的 setInterval：
      // 好处是能在 beforeDestroy 里 clearInterval，避免离开页面后继续计时
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.countdown = 0
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    toggleCountryPop () {
      this.showCountryPop = !this.showCountryPop
    },
    selectCountry (item) {
      this.currentCountry = item
      this.showCountryPop = false
    },
    handleClickOutside () {
      this.showCountryPop = false
    },
    onOtpInput (i, e) {
      // 仅允许数字
      this.otp[i] = (this.otp[i] || '').replace(/\D/g, '').slice(0, 1)
      // 自动跳到下一格
      if (this.otp[i] && i < this.otp.length - 1) {
        this.focusBox(i + 1)
      }
    },
    onOtpBackspace (i, e) {
      // 当前格为空时删除前一格
      if (!this.otp[i] && i > 0) {
        e.preventDefault()
        this.$set(this.otp, i - 1, '')
        this.focusBox(i - 1)
      }
    },
    onOtpPaste (e) {
      e.preventDefault()
      const text = (e.clipboardData || window.clipboardData).getData('text') || ''
      const digits = text.replace(/\D/g, '').slice(0, this.otp.length)
      if (!digits) return
      for (let i = 0; i < this.otp.length; i++) {
        this.$set(this.otp, i, digits[i] || '')
      }
      // 焦点跳到最后一位或末尾
      const nextIdx = Math.min(digits.length, this.otp.length - 1)
      this.focusBox(nextIdx)
      // 若已填满，自动触发确认
      if (digits.length >= this.otp.length) {
        this.$nextTick(() => this.onConfirm())
      }
    },
    focusBox (i) {
      this.$nextTick(() => {
        const ref = this.$refs['otpBox' + i]
        if (ref && ref[0]) ref[0].focus()
      })
    },
    onConfirm () {
      // 校验手机号
      if (!this.phoneValid) {
        Toast(this.$t('lang.bindPhone.invalidPhone'))
        return
      }
      // 校验 OTP
      const snsCode = this.otp.join('')
      if (!snsCode || snsCode.length !== 4) {
        Toast(this.$t('lang.bindPhone.invalidOtp'))
        return
      }
      // 调用绑定接口
      const data = {
        campaignId: localStorage.getItem('cid'),
        mobile: this.phone.replace(/\s/g, ''),
        snsCode: snsCode,
        userId: this.userInfo.userId
      }
      request('post', '/api/user/bind/mobile', data).then(res => {
        if (res && res.code === 200) {
          Toast(this.$t('lang.common.success'))
          // 更新本地 userInfo 中的手机号
          this.userInfo.mobileNo = data.mobile
          localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
          // 返回上一页或首页
          this.$router.go(-1)
        } else {
          Toast(res.message || 'Bind failed')
        }
      }).catch(() => {
        Toast('Bind failed, please try again')
      })
    }
  }
}
</script>

<style lang='less' scoped>
.bindPhonePage {
  position: relative;
  min-height: 100dvh;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: var(--stitch-page-bg);
}

.page-body {
  padding-top: calc(60vw / 3.6); /* TopBack 占位 */
  padding-bottom: calc(24vw / 3.6);
}

/* ---- 通用卡片 ---- */
.card {
  background: var(--stitch-surface);
  border: calc(1vw / 3.6) solid var(--stitch-card-border);
  border-radius: var(--stitch-radius-2xl);
  box-shadow: 0 calc(1vw / 3.6) calc(2vw / 3.6) rgba(0, 0, 0, .04);
}

/* ---- 表单卡 ---- */
.form-card {
  margin: calc(16vw / 3.6) calc(16vw / 3.6) 0;
  padding: calc(16vw / 3.6);
}

.field-label {
  display: block;
  font-size: calc(13vw / 3.6);
  font-weight: 600;
  color: var(--stitch-text-primary);
}

/* 手机号输入组 */
.phone-field {
  position: relative;
}
.phone-input {
  margin-top: calc(8vw / 3.6);
  display: flex;
  align-items: stretch;
  height: calc(48vw / 3.6);
  background: var(--stitch-input-bg);
  border: calc(1vw / 3.6) solid var(--stitch-input-border);
  border-radius: var(--stitch-radius-lg);
  overflow: hidden;
}
.country {
  display: flex;
  align-items: center;
  gap: calc(6vw / 3.6);
  padding: 0 calc(12vw / 3.6);
  background: var(--stitch-country-bg);
  border-right: calc(1vw / 3.6) solid var(--stitch-input-border);
  cursor: pointer;
}
.flag { width: calc(18vw / 3.6); height: calc(18vw / 3.6); border-radius: calc(2vw / 3.6); object-fit: cover; }
.code { font-size: calc(14vw / 3.6); font-weight: 600; color: var(--stitch-text-mid); }
.ic-chev { width: calc(14vw / 3.6); height: calc(14vw / 3.6); color: var(--stitch-text-secondary); }

/* 区号下拉面板（参考 Login 页 .country-pop） */
.country-pop {
  position: absolute;
  top: calc(52vw / 3.6);
  left: 0;
  min-width: calc(112vw / 3.6);
  background: var(--stitch-surface);
  border: calc(1vw / 3.6) solid var(--stitch-input-border);
  border-radius: var(--stitch-radius-lg);
  box-shadow: 0 calc(4vw / 3.6) calc(16vw / 3.6) rgba(0, 0, 0, .12);
  padding: calc(6vw / 3.6) 0;
  z-index: 999;
}
.country-item {
  display: flex;
  align-items: center;
  gap: calc(8vw / 3.6);
  padding: calc(6vw / 3.6) calc(12vw / 3.6);
  font-size: calc(14vw / 3.6);
  color: var(--stitch-text-primary);
  white-space: nowrap;
  cursor: pointer;
}
.country-item:hover { background: var(--stitch-input-bg); }
.country-item.active { color: var(--stitch-brand); font-weight: 600; }
.flag-sm { width: calc(20vw / 3.6); height: calc(14vw / 3.6); border-radius: calc(2vw / 3.6); object-fit: cover; }

.phone {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 0 calc(14vw / 3.6);
  font-size: calc(16vw / 3.6);
  font-weight: 700;
  color: var(--stitch-text-primary);
  letter-spacing: 0.02em;
}

.err-msg {
  margin-top: calc(6vw / 3.6);
  font-size: calc(12vw / 3.6);
  color: var(--stitch-badge-red);
}

/* OTP 标题行 */
.otp-head {
  margin-top: calc(16vw / 3.6);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.resend-pill {
  display: flex;
  align-items: center;
  gap: calc(4vw / 3.6);
  background: var(--stitch-brand-light);
  color: var(--stitch-brand);
  font-size: calc(11vw / 3.6);
  font-weight: 600;
  padding: calc(4vw / 3.6) calc(10vw / 3.6);
  border-radius: var(--stitch-radius-full);
}
.ic-clock { width: calc(12vw / 3.6); height: calc(12vw / 3.6); }

/* Send 态：实心品牌色，与倒计时态区分 */
.resend-pill.send {
  background: var(--stitch-brand);
  color: var(--stitch-surface);
  border: none;
  font-family: inherit;
  font-size: calc(12vw / 3.6);
  padding: calc(5vw / 3.6) calc(14vw / 3.6);
  cursor: pointer;
  transition: background-color .12s ease;
  -webkit-tap-highlight-color: transparent;
}
.resend-pill.send:active { background: var(--stitch-brand-active); }

/* OTP 格子 */
.otp-boxes {
  margin-top: calc(10vw / 3.6);
  display: flex;
  gap: calc(10vw / 3.6);
}
.otp-box {
  flex: 1;
  min-width: 0;
  height: calc(52vw / 3.6);
  background: var(--stitch-input-bg);
  border: calc(1vw / 3.6) solid var(--stitch-input-border);
  border-radius: var(--stitch-radius-lg);
  text-align: center;
  font-size: calc(20vw / 3.6);
  font-weight: 700;
  color: var(--stitch-text-primary);
}
.otp-box:focus {
  outline: none;
  border-color: var(--stitch-brand);
  background: var(--stitch-surface);
}

/* 自动填充提示 */
.auto-fill {
  margin-top: calc(12vw / 3.6);
  display: flex;
  align-items: center;
  gap: calc(6vw / 3.6);
  font-size: calc(11vw / 3.6);
  font-weight: 500;
  color: var(--stitch-brand);
}
.ic-check { width: calc(14vw / 3.6); height: calc(14vw / 3.6); flex-shrink: 0; }

/* 确认按钮 */
.btn-confirm {
  display: block;
  box-sizing: border-box;
  width: calc(100vw - 32vw / 3.6);
  margin: calc(16vw / 3.6);
  height: calc(48vw / 3.6);
  background: var(--stitch-brand);
  color: var(--stitch-surface);
  border: none;
  border-radius: var(--stitch-radius-lg);
  font-size: calc(15vw / 3.6);
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 calc(2vw / 3.6) calc(6vw / 3.6) rgba(0, 81, 223, .22);
}
.btn-confirm:active { background: var(--stitch-brand-active); }
</style>



// WEBPACK FOOTER //
// src/pages/BindPhone/index.vue